import { PackageBinaryParts } from "@common/utils/redline/ooxml/package-binary-parts";

interface RangeOoxmlRead {
    value: string;
}

interface OoxmlReadableRange {
    getOoxml(): RangeOoxmlRead;
}

interface SyncableContext {
    sync(): Promise<void>;
}

export async function readRangeOoxmlsInGroups(
    context: SyncableContext,
    ranges: OoxmlReadableRange[],
    maxGroupChars: number,
): Promise<string[]> {
    const ooxmlsWithoutEmbeddedFonts: string[] = [];
    let groupSize = 1;
    let groupStart = 0;
    while (groupStart < ranges.length) {
        const groupRanges = ranges.slice(groupStart, groupStart + groupSize);
        groupStart += groupRanges.length;
        const reads = groupRanges.map((range) => range.getOoxml());
        await context.sync();
        const valuesAsRead = reads.map((read) => read.value);
        ooxmlsWithoutEmbeddedFonts.push(...valuesAsRead.map((value) => PackageBinaryParts.withoutEmbeddedFonts(value)));
        const largestReadChars = Math.max(1, ...valuesAsRead.map((value) => value.length));
        groupSize = Math.max(1, Math.floor(maxGroupChars / largestReadChars));
    }
    return ooxmlsWithoutEmbeddedFonts;
}
